import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { DialogService } from '@app/shared/dialog/dialog.service';
import { FadeInOut } from '@app/utils/angular-animations';
import { BootstrapSemanticVariation } from '@app/utils/bootstrap';
import { mapRange } from '@app/utils/map-range';
import { StringMap } from '@app/utils/string-map';

@Component({
  selector: 'portal-icon-button',
  templateUrl: './icon-button.component.html',
  styles: [],
  animations: [FadeInOut],
  host: {
    class: 'icon-button',
  },
  standalone: false,
})
export class IconButtonComponent implements OnChanges, OnInit {
  @Input()
  buttonClass: string = 'btn btn-icon btn--portal-link';

  @HostBinding('class.icon-button--disabled')
  @Input()
  disabled: boolean = false;

  @Input()
  iconClass: string | string[] | Set<string> | StringMap<any> = 'far fa-plus-circle';

  @Input()
  loading: boolean = false;

  @Input()
  nyi: boolean = false;

  @Input()
  preventAndStop: boolean = false;

  @Input()
  progress: number = 0;

  @Input()
  returnTo?: string;

  @Input()
  returnToLabel?: string;

  @Input()
  returnToParams?: StringMap<number | string>;

  @Input()
  route?: string;

  @Input()
  routeParams?: StringMap<any>;

  @Input()
  showProgress: boolean = false;

  /**
   * Only used via css (this exists only so the developer knows that the attribute small can be used)
   */
  @Input()
  small: boolean = false;

  @Input()
  tabindex: string = '0';

  @Input()
  variant: BootstrapSemanticVariation | null = null;

  @Output()
  onClick: EventEmitter<MouseEvent> = new EventEmitter();

  public buttonClassName!: string;
  public dashArray: number;
  public radius: number = 16;

  public get progressInPixel() {
    return this.calculateProgressInPixel(this.progress);
  }

  constructor(private dialogService: DialogService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if ('buttonClass' in changes) {
      this.buttonClassName = this.getButtonClass(changes.buttonClass.currentValue);
    }
  }

  ngOnInit() {
    this.buttonClassName = this.getButtonClass(this.buttonClass);
    this.dashArray = Math.PI * this.radius * 2;
    this.nyi = this.nyi !== false;
  }

  public emitClick($event: MouseEvent) {
    if (this.preventAndStop !== false) {
      $event.preventDefault();
      $event.stopPropagation();
    }

    if (this.nyi) {
      this.dialogService.openNyi();
    } else {
      this.onClick.emit($event);
    }
  }

  private calculateProgressInPixel(value) {
    if (value < 0) {
      value = 0;
    }

    if (value > 100) {
      value = 100;
    }

    return mapRange([0, 100], [this.radius * 0.85, this.dashArray], 100 - value);
  }

  private getButtonClass(className: string): string {
    let buttonClass: string = className;

    if (this.variant != null) {
      buttonClass += ` btn-icon--${this.variant}`;
    }

    return buttonClass;
  }
}
